import axiosClient from './axiosClient';

const catalogService = {
    // Menus
    getPublicMenus: () => axiosClient.get('/public/menus'),
    
    // Thuộc tính
    getBrands: () => axiosClient.get('/public/brands'),
    getCategories: () => axiosClient.get('/public/categories'),
    getPurposes: (timestamp = '') => axiosClient.get(`/public/purposes${timestamp ? `?_t=${timestamp}` : ''}`),
    
    // Lấy specs chung hoặc specs theo category
    getSpecs: () => axiosClient.get('/public/specs'),
    getSpecsByCategory: (categoryId) => axiosClient.get(`/public/categories/${categoryId}/specs`),
    
    // Khuyến mãi & Cấu hình
    getPublicSales: () => axiosClient.get('/public/sales'),
    getSystemConfig: () => axiosClient.get('/public/config'),

    recordVisit: () => axiosClient.post('/public/traffic/visit'),
};

export default catalogService;